/* tslint:disable */
export * from './Puesto';
export * from './Turno';
export * from './Numerador';
export * from './Sucursal';
export * from './Totem';
export * from './Sector';
export * from './PadronNosis';
export * from './ConsultasSql';
export * from './PadronOlp';
export * from './Encuestas';
export * from './Preguntas';
export * from './TipoPregunta';
export * from './EncuestaRespuestas';
export * from './EncuestaRespuestasDetalle';
export * from './BaseModels';




// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/shared/lb-sdk/models/index.ts